(function () {
  function details(inhalt) {
    return String(inhalt || '').split(',').map(function (t) {
      var m = /^\s*(.+?)\s*:\s*(\d+)\s*$/.exec(t);
      return m ? m[2] + '× ' + m[1] : '';
    }).filter(Boolean).join(', ');
  }
  // News-Box unter Donuts nur zeigen, wenn „Start – News“ eingeblendet ist (Fallback fuer Browser ohne :has)
  function abgleichen() {
    var karte = document.querySelector('.box-card-news');
    if (karte) karte.style.display = document.querySelector('.nd-news') ? '' : 'none';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abgleichen); else abgleichen();
  document.addEventListener('shopify:section:load', abgleichen);
  document.addEventListener('shopify:section:unload', function () { setTimeout(abgleichen, 0); });
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest ? e.target.closest('.nd-news-kaufen') : null;
    if (!knopf) return;
    var karte = document.querySelector('.box-card[data-box-id="box-news"]');
    if (!karte || !window.NadosCart || karte.classList.contains('is-soldout')) return;   // sonst: Link zur Donuts-Seite
    e.preventDefault();
    var d = details(karte.getAttribute('data-inhalt'));
    var img = karte.querySelector('.box-card-media img');
    var bild = img ? (img.getAttribute('src') || '') : '';
    var name = karte.getAttribute('data-name') || '';
    var variante = karte.getAttribute('data-variant-id');
    if (window.NadosCart.fly) window.NadosCart.fly(knopf);
    var teile = karte.getAttribute('data-teile');
    if (!variante && teile && window.NadosCart.addBox) {
      var basis = (window.NadosAuswahl && window.NadosAuswahl.vollstaendig() && window.NadosFulfillmentProps) ? window.NadosFulfillmentProps() : {};
      window.NadosCart.addBox(window.NadosCart.boxFromCard(karte, 1, basis));
    } else if (variante) {
      var props = (window.NadosAuswahl && window.NadosAuswahl.vollstaendig() && window.NadosFulfillmentProps) ? window.NadosFulfillmentProps() : {};
      props['Sorten'] = d;
      window.NadosCart.addVariant(variante, 1, props, { id: 'box-news', name: name, preis: karte.getAttribute('data-price') || '', bild: bild, details: d });
    } else {
      window.NadosCart.add('box-news', name, karte.getAttribute('data-price') || '', bild, d, 1);
    }
    window.NadosCart.open(true);
  });
})();
;
(function () {
  var SHOP = !!(window.Shopify && window.fetch);
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function el(id) { return document.getElementById(id); }
  function modus() {
    var a = document.querySelector('.fulfillment-option.active');
    return a ? a.getAttribute('data-fulfillment') : '';
  }
  function stand() {
    var m = modus(), d = el('abholdatum'), z = el('abholuhrzeit');
    if (m === 'lieferung') return { Versandart: 'Lieferung', Abholdatum: d ? d.value : '', Abholuhrzeit: z ? z.value : '' };   // Datum/Uhrzeit gelten auch fuer die Lieferung
    if (m === 'abholung') return { Versandart: 'Abholung', Abholdatum: d ? d.value : '', Abholuhrzeit: z ? z.value : '' };
    return null;                                   // Seite ohne Auswahlfelder
  }
  function vollstaendig(s) {
    s = s || stand();
    return !!(s && (s.Versandart === 'Lieferung' || s.Versandart === 'Abholung') && s.Abholdatum && s.Abholuhrzeit);
  }
  var gemerkt = null;                              // zuletzt im Warenkorb gespeicherte Auswahl
  var wartet = false;                              // Kunde wurde zur Auswahl geschickt
  function speichern(s, erzwingen) {
    if (!SHOP || !vollstaendig(s)) return Promise.resolve();
    var key = JSON.stringify(s);
    if (!erzwingen && key === JSON.stringify(gemerkt)) return Promise.resolve();
    gemerkt = s;
    return fetch(root() + 'cart/update.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attribute(s), note: termin(s) }) }).catch(function () {});
  }
  function termin(s) {
    return (s && s.Versandart === 'Lieferung' ? 'Lieferung am ' : 'Abholung am ') + s.Abholdatum + ' um ' + s.Abholuhrzeit + ' Uhr';
  }
  // Warenkorb-Attribute: bei Lieferung als Lieferdatum/Lieferuhrzeit, bei Abholung als Abholdatum/Abholuhrzeit
  function attribute(s) {
    var l = s.Versandart === 'Lieferung';
    return { Versandart: s.Versandart, Abholdatum: l ? '' : s.Abholdatum, Abholuhrzeit: l ? '' : s.Abholuhrzeit,
      Lieferdatum: l ? s.Abholdatum : '', Lieferuhrzeit: l ? s.Abholuhrzeit : '', Lieferart: termin(s) };
  }
  // Alle Artikel bekommen dieselbe Angabe „Lieferart“ (wird im Checkout unter jedem Artikel angezeigt)
  var ALT = ['Abholung', 'Abholdatum', 'Abholuhrzeit', 'Lieferung', 'Lieferdatum', 'Lieferuhrzeit', 'Lieferart'];
  function zeilenAbgleichen(s) {
    if (!SHOP || !vollstaendig(s)) return Promise.resolve();
    var t = termin(s);
    return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var kette = Promise.resolve();
        (c.items || []).forEach(function (it) {
          var alt = it.properties || {}, neu = {}, anders = alt['Lieferart'] !== t;
          Object.keys(alt).forEach(function (k) {
            if (ALT.indexOf(k) > -1) { if (k !== 'Lieferart') anders = true; return; }
            if (alt[k] !== null && alt[k] !== '') neu[k] = alt[k];
          });
          if (!anders) return;
          neu['Lieferart'] = t;
          kette = kette.then(function () {
            return fetch(root() + 'cart/change.js', { method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: neu }) }).catch(function () {});
          });
        });
        return kette;
      }).catch(function () {});
  }
  function hinweis(zeigen) {
    var akt = document.querySelector('.cart-aktionen');
    if (!akt) return;
    var p = akt.querySelector('.cart-pflicht');
    if (!zeigen) { if (p) p.remove(); return; }
    if (!p) {
      p = document.createElement('p'); p.className = 'cart-pflicht'; p.setAttribute('role', 'alert');
      akt.insertBefore(p, akt.firstChild);
    }
    var t = (window.NadosTexte && window.NadosTexte.__pflicht) || 'Bitte wähle vor dem Bezahlen Abholung oder Lieferung mit Datum und Uhrzeit.';
    p.textContent = window.NadosI18n ? window.NadosI18n.t(t) : t;
  }
  function zurAuswahl() {
    var docked = window.NadosCart && window.NadosCart.docked && window.NadosCart.docked();
    if (!document.querySelector('.fulfillment-row')) { window.location.href = root() + '#donuts'; return; }
    if (location.hash !== '#donuts') location.hash = 'donuts';
    setTimeout(function () {
      var ziel = document.querySelector('.fulfillment-row');
      if (ziel) {
        var r = ziel.getBoundingClientRect();
        window.scrollTo(0, Math.max(r.top + (window.pageYOffset || 0) - 120, 0));
      }
      if (modus()) {
        var d = el('abholdatum'), z = el('abholuhrzeit');
        var fehlt = (d && !d.value) ? d : (z && !z.value ? z : null);
        if (fehlt) { fehlt.classList.add('field-error'); fehlt.classList.remove('field-shake'); void fehlt.offsetWidth; fehlt.classList.add('field-shake'); }
      }
    }, 80);
    if (!docked && window.NadosCart && window.NadosCart.close) window.NadosCart.close();
  }
  // Gespeicherte Auswahl beim Laden wieder in die Felder schreiben
  // Nur Abholung oder Lieferung wieder anwählen. Datum und Uhrzeit starten leer und werden jedes Mal neu gewählt;
  // bis dahin gilt die Auswahl als unvollständig und „Zur Kasse“ führt zur Auswahl.
  function vorbelegen(attr) {
    if (!attr || !attr.Versandart) return;
    var opt = document.querySelector('.fulfillment-option[data-fulfillment="' + (attr.Versandart === 'Lieferung' ? 'lieferung' : 'abholung') + '"]');
    if (opt && !opt.classList.contains('active')) opt.click();
    gemerkt = { Versandart: attr.Versandart, Abholdatum: '', Abholuhrzeit: '' };
    document.body.click();                         // Anzeige im Warenkorb aktualisieren
  }
  if (SHOP) {
    var laden = function () {
      fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { vorbelegen(c && c.attributes); }).catch(function () {});
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', laden); else laden();
  }
  // Nach jeder Aenderung der Auswahl: speichern, Hinweis entfernen, ggf. Warenkorb wieder oeffnen
  document.addEventListener('click', function () {
    setTimeout(function () {
      var s = stand();
      if (!vollstaendig(s)) return;
      speichern(s);
      hinweis(false);
      if (wartet) { wartet = false; if (window.NadosCart && window.NadosCart.open) window.NadosCart.open(false); }
    }, 0);
  }, true);
  // „Zur Kasse“ im Warenkorb (Capture-Phase: laeuft vor dem bisherigen Klick)
  document.addEventListener('click', function (e) {
    var k = e.target.closest ? e.target.closest('.cart-kasse') : null;
    if (!k) return;
    e.preventDefault(); e.stopPropagation();
    var s = stand();
    var weiter = function () {
      hinweis(false);
      if (SHOP) speichern(s, true).then(function () { return zeilenAbgleichen(s); }).then(function () { window.location.href = root() + 'checkout'; });
    };
    if (vollstaendig(s)) { weiter(); return; }
    if (!s && vollstaendig(gemerkt)) { s = gemerkt; weiter(); return; }
    hinweis(true);
    wartet = true;
    zurAuswahl();
  }, true);
  // Warenkorb-Seite: „Zur Kasse“ ebenfalls erst nach dem Abgleich
  document.addEventListener('click', function (e) {
    var k = e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (!k || !SHOP || !vollstaendig(gemerkt)) return;
    e.preventDefault(); e.stopPropagation();
    var g = gemerkt;
    speichern(g, true).then(function () { return zeilenAbgleichen(g); }).then(function () { window.location.href = root() + 'checkout'; });
  }, true);
  window.NadosAuswahl = { vollstaendig: function () { return vollstaendig(); }, stand: stand };
})();
